import { StickyActionElement } from "@omni/types/components/general/enums/stickyActionElement.enum";
import { Environment } from "@omni/types/enums/environment.enum";
import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { isDefined } from "@omni/utils/helper.utils";
import { entries } from "@omni/utils/object.utils";
import { cn } from "@omni/utils/styles";
import queryString from "query-string";
import { useRef, useState } from "react";

import { StickyAction } from "@/components/StickyAction/stickyAction";
import {
    useFeatureToggle,
    useFeatureToggleContext
} from "@/context/featureToggles.context";
import FeatureTogglesService from "@/services/featureToggle/featureToggles.service";
import { Config } from "@/utils/config.utils";
import { useOutsideAlerter } from "@/utils/hooks/useOutsideAlerter";

import { FeatureSwitchComponent } from "./featureSwitch.component";

const FeatureSwitchContainer = () => {
    const [isOpen, setIsOpen] = useState(false);

    const featureToggles = useFeatureToggleContext();

    const featureSwitchUiEnabled = useFeatureToggle(
        FeatureToggleKey.DEBUG_FEATURE_SWITCH_UI
    );

    const drawerRef = useRef<HTMLDivElement | null>(null);
    const triggerRef = useRef<HTMLButtonElement | null>(null);

    useOutsideAlerter(
        () => {
            handleOnToggleDrawer(false);
        },
        drawerRef,
        [triggerRef]
    );

    const features = entries(featureToggles).map(([key, value]) => ({
        name: key,
        value: value,
        serverValue: Config["feature-toggles"][key] ?? null
    }));

    const isEnabled =
        isDefined(Config.general.environment) &&
        Config.general.environment !== Environment.Prod &&
        (featureSwitchUiEnabled ||
            queryString.parse(location.search, { parseBooleans: true })
                .featureswitchui);

    const handleOnToggleDrawer = (state?: boolean) => {
        if (state !== undefined) {
            setIsOpen(state);
            return;
        }

        setIsOpen((state) => !state);
    };

    const handleOnToggleFeature = (name: FeatureToggleKey, value: boolean) => {
        FeatureTogglesService.setFeature(name, value);
    };

    if (!isEnabled) {
        return null;
    }

    return (
        <>
            <FeatureSwitchComponent
                isOpen={isOpen}
                features={features}
                ref={drawerRef}
                onToggle={handleOnToggleDrawer}
                onToggleFeature={handleOnToggleFeature}
            />
            <StickyAction
                stickyActionElement={StickyActionElement.FeatureSwitchButton}
            >
                <Button
                    type={"button"}
                    color={"warning"}
                    ref={triggerRef}
                    onClick={() => handleOnToggleDrawer()}
                >
                    <i className={cn("las la-sliders-h")} />
                </Button>
            </StickyAction>
        </>
    );
};

export { FeatureSwitchContainer };
